import { render, staticRenderFns } from "./LMS.vue?vue&type=template&id=d1485ed4"
import script from "./LMS.vue?vue&type=script&lang=js"
export * from "./LMS.vue?vue&type=script&lang=js"
import style0 from "./LMS.vue?vue&type=style&index=0&id=d1485ed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports